"use client";

import Script from "next/script";
import FullStoryRouteScript from "./FullStoryRouteScript";
const RootScripts = () => {
  return <>
      <Script id='google-maps-init' strategy='beforeInteractive' dangerouslySetInnerHTML={{
      __html: `
              window.googleMapsLoaded = false;
              window.initGoogleMaps = () => {
                window.googleMapsLoaded = true;
              }`
    }} data-sentry-element="Script" data-sentry-source-file="scripts.tsx" />
      <Script strategy='afterInteractive' src={`https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_API_KEY_REFERER_ACCESS || ""}&libraries=places,geometry&v=weekly&loading=async&callback=initGoogleMaps`} data-sentry-element="Script" data-sentry-source-file="scripts.tsx" />
      <Script strategy='lazyOnload' src={`https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js`} data-sentry-element="Script" data-sentry-source-file="scripts.tsx" />
      <Script strategy='lazyOnload' src='https://accounts.google.com/gsi/client' referrerPolicy='no-referrer-when-downgrade' data-sentry-element="Script" data-sentry-source-file="scripts.tsx" />
      <Script id='aws-waf-challenge' strategy='afterInteractive' src='https://457e4f12bc81.edge.sdk.awswaf.com/457e4f12bc81/0a93ea05afdd/challenge.js' data-sentry-element="Script" data-sentry-source-file="scripts.tsx" />

      <FullStoryRouteScript data-sentry-element="FullStoryRouteScript" data-sentry-source-file="scripts.tsx" />
    </>;
};
export default RootScripts;